<div class="flex-row-split height100p">
    <div class="flex-item-fixed flex-col width400 height100p">
        <p-tree #configsTreeComponent class="flex-item-fill full-height tree-items-full-width" [style.height]="showOutline ? '70%' : '100%'" [value]="scriptsTree" selectionMode="single"
                        [(selection)]="scriptsTreeSelected" (selectionChange)="selectScript()">
            <ng-template let-node pTemplate="default">
                <tree-item-with-icons [label]="node.label" [icons]="getNodeIcons(node)"></tree-item-with-icons>
            </ng-template>
        </p-tree>
        @if (showOutline) {
            <p-tree class="tree-items-full-width full-height mt-1" [style.height]="'30%'" [value]="outlineTree" selectionMode="single">
                <ng-template let-node pTemplate="default">
                    <tree-item-with-icons [label]="node.label" [icons]="getOutlineNodeIcons(node)" (onClickIcon)="clickOutlineItem($event, node.data)"></tree-item-with-icons>
                </ng-template>
            </p-tree>
        }
    </div>
    <div class="flex-item-fill flex-col">
        <sm-toolbar class="flex-item-fixed" [class.hidden]="sel==null" [center]=true>
            <button pButton [disabled]="!canSave()" icon="fas fa-save" label="Speichern" (click)="save()">
            </button>
            <button pButton icon="fas fa-syntax" label="Syntax prüfen" (click)="syntaxCheck()">
            </button>
            <p-checkbox class="mr-3" name="showIncluded" label="Inkludierte Skripte anhängen" [(ngModel)]="showIncluded" [binary]="true" (ngModelChange)="calculateCode()"></p-checkbox>
            <input pInputText class="width300" type="text" placeholder="Suche" [(ngModel)]="searchText" (keypress)="search($event)"/>
            <p-checkbox name="searchRegex" label="Regex" [(ngModel)]="searchRegex" [binary]="true"></p-checkbox>
            
            <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
        </sm-toolbar>
        @if (pastVersionsListItems?.length > 1) {
            <sm-toolbar class="flex-item-fixed"  [class.hidden]="sel==null" [center]=true>
                <p-checkbox name="compareVersions" label="Vergleiche" [(ngModel)]="compareVersions" [binary]="true" (ngModelChange)="updatePastVersionsListItems()"></p-checkbox>
                <span class="ml-3">Linke Seite:</span>
                <p-dropdown [options]="pastVersionsListItems" [(ngModel)]="selectedPastVersion1"></p-dropdown>
                <span class="ml-3">Rechte Seite:</span>
                <p-dropdown [options]="pastVersionsListItems" [(ngModel)]="selectedPastVersion2"></p-dropdown>
                <p-checkbox name="sideBySide" label="Side-By-Side" [(ngModel)]="sideBySide" [binary]="true"></p-checkbox>
            </sm-toolbar>
        }
        @if(pastVersionsListItems?.length > 1 && sel != null && compareVersions) {
            <app-text-diff class="flex-item-fill" [class.hidden]="sel==null" [left]="selectedPastVersion1?.code ?? code" [right]="selectedPastVersion2?.code ?? code" [sideBySide]="sideBySide">
            </app-text-diff>
        }
        @else {
            <app-ace-editor #aceEvent class="flex-item-fill"  [class.hidden]="sel==null"[(text)]="code" [mode]="sel?.language" [validateCallback]="validate" (contextMenu)="contextMenu($event)" (clickToken)="clickToken($event)"></app-ace-editor>
        }
        <p-tabView *ngIf="searchResults.length > 0" class="flex-item-fixed height300 full-height mt-3" [(activeIndex)]="searchResultTabIndex" [controlClose]=true (onClose)="closeSearchResultsTab($event)">
            <p-tabPanel *ngFor="let result of searchResults; index as index" [header]="result.title" [closable]=true>
                 <!--- Das machen wir, damit bei jedem Öffnen eines Tabs die Selektion entfernt wird. Sonst kann man bei nur einem Ergebnis, die Zeile nicht mehr selektieren -->
                @if(index == searchResultTabIndex) {
                    <sm-table2 class="height100p monospace" [data]="result.guiTable" (onRowSelect)="selectFound($event)"></sm-table2>
                }
            </p-tabPanel>
        </p-tabView>
    </div>
</div>
